<template>
  <ul class="list">
    <li v-for="item in letters "  class="item" 
    :ref="item"
    :key="item"
     @touchstart.prevent="handleTouchStart"
     @touchmove="handleTouchMove"
     @touchend="handleTouchEnd"
     @click="handleLetterClick"
     >
     {{item}}
    </li>

  </ul>
</template>

<script>
import { userslist } from '../../../assets/js/url';
export default {
  name: 'CityAlphabet',
  props: {
    userList:Object
  },
  computed: {
    letters () {
      const letters = []
      for (let i in this.userList) {
        letters.push(i)
      }
      return letters
    }
  },
  data () {
    return {
      touchStatus: false,
      startY: 0,
      timer: null,
    }
  },
  updated () {

    this.startY = this.$refs['A'][0].offsetTop
  },
  methods: {
    handleLetterClick (e) {
      // @touchstart.prevent="handleTouchStart"
      // @touchmove="handleTouchMove"
      // @touchend="handleTouchEnd"
      console.log( e)
      this.$emit('change', e.target.innerText)
    },
    handleTouchStart () {
      this.touchStatus = true
    },
    handleTouchMove (e) {
      if (this.touchStatus) {
        const startY = this.$refs['A'][0].offsetTop 
        this.timer = setTimeout(() => {
          const touchY = e.touches[0].clientY - 200
          const index = Math.floor((touchY - this.startY) / 27)
          console.log(index)
          if (index >= 0 && index < this.letters.length) {
            this.$emit('change', this.letters[index])
          }
        }, 16)
      }
    },
    handleTouchEnd () {
      this.touchStatus = false
    }
  }
}
</script>

<style  scoped>

  .list{
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 1.58rem;
    right: 0;
    bottom: 0;
    width: 0.4rem;
  }
    
  .list .item{
      line-height: 0.25rem;
      text-align: center;
      color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/userlist/Alphabet.vue